<template>
  <v-list-item>
    <v-list-item-content>
      <v-row no-gutters>
        <v-col class="text-left">
          <small>{{name}}</small>
        </v-col>
        <v-col>
          <small>{{ value }} {{type}}</small>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "CommandDetailListItem",
  components: {},
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      default: ""
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>
